import { APP_ENV } from '@common/config/api';

export const getEnvVar = (key: string) => {
  return import.meta.env[key] as string;
};

export const isDevelopment = () => {
  return APP_ENV === 'development' || APP_ENV === 'refector';
};
